import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const StudentProfile = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (state === null) {
      alert("no student details");
      navigate("..");
    }
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">Center</h4>

            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="../">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Student Profile</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12 mb-5 card py-3 px-3">
          <div className="d-flex align-items-center flex-row">
            <div className="flex-grow-1">
              <h2 className="fs-20 fw-bold mb-1">Student Profile</h2>
            </div>
            <div className="mt-3 mt-lg-0">
              <Link to="../" className="mb-2">
                Go Back
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12 mb-5">
          <div
            className="profile-image-box"
            style={{
              height: "200px",
              width: "200px",
              border: "2px solid #ccc",
              borderRadius: "50%",
            }}
          >
            <img
              src="https://res.cloudinary.com/oluwatoyinah/image/upload/v1680967600/a1tutor/avatar-user-icon-vector_97886-15026_kihclx.avif"
              style={{  
                borderRadius: "50%",
              }}
              alt="profile pic"
            />
          </div>
        </div>

        <div className="col-lg-4 col-md-6 mb-3">
          <label>First Name</label>
          <input
            className="form-control bg-white"
            value={state?.student?.first_name || "No first name"}
            type="text"
            name=""
            readOnly
            id=""
          />
        </div>
        <div className="col-lg-4 col-md-6 mb-3">
          <label>Last Name</label>
          <input
            className="form-control bg-white"
            value={state?.student?.last_name || "No Last name"}
            type="text"
            name=""
            readOnly
            id=""
          />
        </div>
        <div className="col-lg-4 col-md-6 mb-3">
          <label>Email</label>
          <input
            className="form-control bg-white"
            value={state?.student?.email || "No email"}
            type="text"
            name=""
            readOnly
            id=""
          />
        </div>
        <div className="col-lg-4 col-md-6 mb-3">
          <label>Phone Number</label>
          <input
            className="form-control bg-white"
            value={state?.student?.phone || "No phone number"}
            type="text"
            name=""
            readOnly
            id=""
          />
        </div>
        <div className="col-lg-4 col-md-6 mb-3">
          <label>Class Level</label>
          <input
            className="form-control bg-white"
            value={state?.student?.class_level || "No class Level"}
            type="text"
            name=""
            readOnly
            id=""
          />
        </div>
        <div className="col-lg-4 col-md-6 mb-3">
          <label>Category</label>
          <input
            className="form-control bg-white"
            value={state?.student?.category || "No category"}
            type="text"
            name=""
            readOnly
            id=""
          />
        </div>

        <div className="col-lg-4 col-md-6 mb-3">
          <label>Regsitration Date</label>
          <input
            className="form-control bg-white"
            value={new Date(state?.student?.created_at).toLocaleDateString("en-us", {
              hour12: true,
              day: "numeric",
              month: "short",
              year: "numeric",
            })}
            type="text"
            name=""
            readOnly
            id=""
          />
        </div>

        <div className="col-lg-4 col-md-6 mb-3">
          <label>Total quiz attempted</label>
          <input
            className="form-control bg-white"
            value={state?.student?.total_quiz_attempted}
            type="text"
            name=""
            readOnly
            id=""
          />
        </div>

        <div className="col-lg-4 col-md-6 mb-3">
          <label>Center Referral Code</label>
          <input
            className="form-control bg-white"
            value={state?.student?.referral_code}
            type="text"
            name=""
            readOnly
            id=""
          />
        </div>
      </div>
    </div>
  );
};

export default StudentProfile;
